class GuestlistActionService {
    constructor($http) {
        this.api = $http;
    }

    getAvailableFieldsForGuestlist(guestlistId) {
        return this.api.get(`guestlists/${guestlistId}/available-fields`).then((response) => {
            return response.data.data;
        }, (e) => {
            return e;
        })
    }

    getDefaultAvailableFieldsForGuestlist() {
        return this.api.get(`guestlists/defaults/available-fields`).then((response) => {
            return response.data.data;
        }, (e) => {
            return e;
        })
    }
}


angular
    .module('festzelt-os.guestlists')
    .service('GuestlistActionService', ['$http', ($http) => new GuestlistActionService($http)]);



// WEBPACK FOOTER //
// ./src/app/pages/guestlists/services/guestlist-action-service.js